var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__info--system icon--style--fill icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M8 0a8 8 0 108 8 8 8 0 00-8-8zm.75 10.909a.75.75 0 01-1.5 0V7.636a.75.75 0 011.5 0zM8 5.818a.75.75 0 11.75-.75.75.75 0 01-.75.75z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }